var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { createGridSelectionRowRenderer } from "../../renderers/selectionGridRow";
import { gridCheckboxCell } from "../../renderers/gridCheckboxCell";
import { gridHeaderCheckboxCell } from "../../renderers/gridHeaderCheckboxCell";
import { designTokens } from "../../../design/tokens";
import React from 'react';
import { GridSelectionSubheader } from "./GridSelectionSubheader";
var SELECTION_COLUMN_ID = '__internalSelectionColumn__';
// isSelected(), selected: [], removeItem(), addItem(); getItemIndex(item), getSelectedItem();
// isSelected(); selected: [], removeItem(), addItem(); getItemIndex(item), getSelectedItem(); is
// interface SelectionValue {
//     select(): void;
//     toggleSelect(): void;
//     shiftSelect(): void;
//     isSelected(): boolean;
// }
export function gridMultiSelectionPlugin(config) {
    var selectColumnSize = designTokens.gridIconControlColumnSize.getIntValue() || 32;
    // if (isShift && value.length) {
    //     const edgeItemSelectedIndex = data.findIndex((i) => i.id  === value[value.length - 1]);
    //
    //     const start = Math.min(edgeItemSelectedIndex, index);
    //     const end = Math.max(edgeItemSelectedIndex, index);
    //     let nextValue  = [];
    //
    //     for (let i = start; i <= end; i++) {
    //         nextValue.push(data[i].id);
    //     }
    //
    //     if (index > edgeItemSelectedIndex) {
    //         nextValue = nextValue.reverse();
    //     }
    //     selectionState.setValue(nextValue);
    //     return;
    // }
    return function () {
        // isSelected(), selected, removeItem(), addItem(); getItemIndex(item), getSelectedItem();
        // function onMultiSelect(index: number)  {
        //     const currentSelectedItem = data[index];
        //
        //     if (isSelected(currentSelectedItem)) {
        //         onSelectionChange(
        //             removeItem(currentSelectedItem)
        //         )
        //         return;
        //     }
        //
        //     onSelectionChange(
        //        addItem(currentSelectedItem)
        //     )
        // }
        return {
            rowRenderer: createGridSelectionRowRenderer({
                onSelect: config.onSelect,
                isSelected: config.isSelected,
                isDisabled: config.isRowDisabled,
                onMultiSelect: config.onMultiSelect,
                onContextMenu: config.onContextMenu,
                onRowClick: config.onRowClick
            }),
            processColumns: function (columns) {
                if (!columns.filter(function (i) { return !i.isService; }).length) {
                    return [];
                }
                return __spreadArrays([
                    {
                        id: SELECTION_COLUMN_ID,
                        width: selectColumnSize,
                        order: -1,
                        isService: true,
                        header: gridHeaderCheckboxCell({
                            onClick: config.onAllSelect,
                            isChecked: config.isAllSelected
                        }),
                        cell: gridCheckboxCell({
                            onClick: function (index) { return config.onMultiSelect(index, false); },
                            isChecked: config.isSelected,
                            isDisabled: config.isRowDisabled
                        })
                    }
                ], columns);
            },
            subheaderAddons: [
                {
                    id: 'selection-subheader',
                    order: -1,
                    render: function () {
                        // TODO: hooks error???
                        if (!config.subheader) {
                            return React.createElement(React.Fragment);
                        }
                        if (typeof config.subheader === 'function') {
                            return config.subheader();
                        }
                        return React.createElement(GridSelectionSubheader, {
                            selected: config.subheader.selected,
                            total: config.subheader.total
                        });
                    }
                }
            ]
        };
    };
}
//# sourceMappingURL=gridMultiSelectionPlugin.js.map